<template>
<!-- The Modal contains the KeywordSearch, TreeView and DetailPane components -->
  <div class="open-services-tree-naics-lookup modal-card" style="width: auto">
    <header class="modal-card-head">
      <div v-if="error" class="error">
        <open-services-errors-component
          :lang="this.mx_toggleLang"
          @closed="error = null"
        ></open-services-errors-component>
      </div>
      <div>
        <KeywordSearch
          :lang="this.mx_toggleLang"
          :bpdata_selectionid="this.getAllSavedValues"
          @update="updateTree"
          @errored="getError"
        ></KeywordSearch>
      </div>    
    </header>
    <div class="modal-card-body">
      <div class="columns">
        <div class="column is-three-fifths">
          <div class="divscroll">
            <div class="scrollpane">
              <TreeView
                :lang="this.mx_toggleLang"
                :multiple="this.mx_toggleMultiple"
                :bpdata_newtreedata="this.getTreeData"  
                :bpdata_itemselected="this.getAllCheckedValues.naics"
                :showCode="this.showCode"
                :bpdata_clearall="this.clearAll"
                @bpdata_selection="mx_treeSelection"
                @getDetail="detailId"
                @cleared="treeCleared"
              ></TreeView>
            </div>
          </div>
        </div>
        <div class="column is-two-fifths">
          <DetailPane
            ref="detailPane"
            :lang="this.mx_toggleLang"
            :multiple="this.mx_toggleMultiple"
            :bpdata_id="this.detailID"
            @errored="getError"
          ></DetailPane>
        </div>
      </div>
    </div>
    <footer class="modal-card-footer">
      <b-button class="save-button" :label="$t('save_text')" :disabled="this.getHasNoSelection" tabindex="0" @click="saveSelection()" />
      <b-button class="cancel-button" :label="$t('cancel_button')" tabindex="0" @click="cancel()" />
      <small>
        {{ 
          this.getAllCheckedValues.naics.length > 1 
            ? this.getAllCheckedValues.naics.length + "&nbsp;" + $tc('selection', 2) 
            : this.getAllCheckedValues.naics.length == 1 
              ? this.getAllCheckedValues.naics.length + "&nbsp;" + $tc('selection', 1) 
              : "" 
        }}
        <span v-if="this.getHasNoSelection">{{ mx_toggleMultiple ? $tc("save_label", 2) : $tc('save_label', 1) }}</span>
        <span v-if="this.getAllCheckedValues.naics.length != 0">
          &nbsp;(<a role="link" class="clear-button" tabindex="0" @keydown.enter.exact.prevent="clear" @click="clear()">
            {{ $t('clear') }}
          </a>)
        </span>
      </small>
      <div class="faq-footer">
        <a :href="this.FAQLink" target="_blank" :title="$t('faq')" @click="GAHandler"><abbr :title="$t('faq')">{{ $t('faqAbbr') }}</abbr></a>
      </div>
    </footer>
  </div>
</template>

<script>
import TreeView from "./TreeView.vue";
import KeywordSearch from "./KeywordSearch.vue";
import DetailPane from "./DetailPane.vue";
import OpenServicesErrorsComponent from "@bizpal/open-services-errors-component";

export default {
  name: "ModalHome",
  i18n: {
    locale: "en",
    messages: {
      en: {
        cancel_button: "Cancel",
        save_label: "Select an industry to continue | Select at least one result to continue",
        save_text: "Save",
        no_option: "Sorry, no matching option",
        no_result: "No industries found...",
        selection: "industry selected | industries selected",
        label: "Select your industry | Select your industries",
        clear: "Clear All",
        faq: "Frequently Asked Questions",
        faqAbbr: "FAQ"
      },
      fr: {
        cancel_button: "Annuler",
        save_label: "Choisissez une industrie pour continuer | Choisissez au moins une industrie pour continuer",
        save_text: "Sauvegarder",
        no_option: "Désolé, aucunes options correspondantes.",
        no_result: "Aucunes industries trouvées...",
        selection: "industrie sélectionnée | industries sélectionnées",
        label: "Trouvez votre industrie | Trouvez vos industries",
        clear: "Effacer tout",
        faq: "Foire aux questions",
        faqAbbr: "FAQ"
      }
    }
  }, // end i18n
  data: function() {
    return {
      FAQLink: process.env.VUE_APP_FAQ,
      detailID: "",
      showDetail: false,
      error: null,
      clearAll: false
    };
  }, // end data
  components: { TreeView, DetailPane, KeywordSearch, OpenServicesErrorsComponent },
  created: function() {
    this.$i18n.locale = this.mx_toggleLang;
    this.updateHasResults(false);
  }, // end created
  computed: {
    getTreeData: function() {
      return this.getReducedTree;
    }
  }, // end computed
  methods: {
    clear: function() {    
      this.$gtag.event("industries-clear-all", {
        event_category: "naics-tree-widget",
        event_label: "user clear all industries selection",
        product: process.env.VUE_APP_PRODUCT
      });
      this.clearAll = true;
      this.updateShowDetail(false);
    }, // end clear
    treeCleared: function() {
      this.clearAll = false;
    }, // end treeCleared
    updateTree: function(event) {
      this.updateReducedTree(event);
    },
    treeValues: function(event) {
      this.updateAllSaved({
        key: "naics",
        payload: event
      });
    }, // end treeValues
    detailId: function(event) {
      this.detailID = event;
    }, // end detailId
    hasDetail: function(event) {
      this.showDetail = event;
    }, // end hasDetail
    getError: function(event){
      this.error = event;
    }, // end getError
    updateExamples: function(event) {
      this.bpdata_examplesByNaics = event;
    }, // end updateExamples
    saveSelection: function() {
      this.updateAllSaved({
        key: "naics",
        payload: this.getAllCheckedValues['naics']
      });
      this.updateSavedTree(this.getReducedTree);
      this.$emit("bpdata_selection", false);
      this.$emit("save",this.getAllSavedValues);
      // track naics selected by users
      this.getAllSavedValues.naics.forEach(naics => {
        this.$gtag.customMap({ 'dimension3': "keyword", "dimension2": "naics" });
        this.$gtag.event("industry-selected", {
          event_category: "naics-tree-widget",
          event_label: naics.name,
          keyword: this.getSearchKeyword,
          naics: naics.code,
          product: process.env.VUE_APP_PRODUCT
        });
        this.$emit("close");
      });
    }, // end saveSelection
    cancel: function() {
      if (this.getAllSavedValues["naics"].length == undefined || this.getAllSavedValues["naics"].length == 0) {              
        this.updateAllChecked({
          key: "naics",
          payload: []
        });
        this.updateHasNoSelection(true);      
        this.updateHasResults(false);
        this.updateReducedTree(this.getInitTree);
        this.updateSearchKeyword("");
      }     
      this.$emit('close');
    }, // end cancel
    GAHandler: function () {      
      this.$gtag.event("FAQ-clicked", {
        event_category: "naics-tree-widget",
        event_label: "user clicked on the FAQ link",
        product: process.env.VUE_APP_PRODUCT
      });      
    } // end GAHandler
  } // end methods
}; // end export default
</script>

<style>
/* for all screens */
.open-services-tree-naics-lookup .modal-card {
  background-color: #fff;
  width: 80vw;
}
.open-services-tree-naics-lookup .modal-card-head {
  padding: 15px;
  background-color: #38598a;
}
.open-services-tree-naics-lookup .modal-card-head > div {
  width: 50%;
}
.open-services-tree-naics-lookup .modal-card-footer {
  padding: 15px;
  background-color: #38598a;
}
.open-services-tree-naics-lookup .save-button {
  background-color: #fff;
  color: #38598a;
  margin-right: 6px;
}
.open-services-tree-naics-lookup .save-button:focus {
  background-color: #167df0;
  color: rgba(255,255,255,1);
  margin-right: 6px;
}
.open-services-tree-naics-lookup .clear-button {
  background-color: transparent;
  color: rgba(255,255,255,0.8);
  text-decoration: underline;
}
.open-services-tree-naics-lookup .cancel-button {
  background-color: transparent;
  border: 1px solid rgba(255,255,255,0.8);
  color: rgba(255,255,255,0.8);
  margin-right: 10px;
}
.open-services-tree-naics-lookup .cancel-button:hover {
  background-color: transparent;
  border: 1px solid rgba(255,255,255,1);
  color: rgba(255,255,255,1);
  margin-right:10px;
}
.open-services-tree-naics-lookup .cancel-button:focus {
  background-color: #167df0;
  border: 1px solid rgba(255,255,255,1);
  color: rgba(255,255,255,1);
  margin-right: 10px;
}
.open-services-tree-naics-lookup .modal-card-body {
  overflow: hidden;
  height: 90vh;
  padding: 0px;
}
.open-services-tree-naics-lookup .modal-card-footer {
  color: #fff;
  line-height: 2.4;
}
.open-services-tree-naics-lookup .modal-card-body .divscroll {
  height: 78vh ;
  overflow: auto;
  position: relative;
}
.open-services-tree-naics-lookup .modal-card-body .scrollpane {
  padding: 20px;
  padding-bottom: 180px;
}
.open-services-tree-naics-lookup .faq-footer  {
  display: inline;
  padding-right: 15px;
  position: absolute;
  right: 0px;
}
@media (min-width: 767px) {
  .open-services-tree-naics-lookup .faq-footer > a {
    color: #fff;
    background-color: transparent;
  }
}
</style>
